<template>
  <form>
    <div class="mb-4 flex flex-col gap-4 lg:flex-row">
      <InputText
        class="flex-1"
        label="Имя"
        name="name"
      />
      <InputText
        class="flex-1"
        label="Номер телефона"
        name="phone"
        locked
      />
    </div>
    <OrderDialogSelectAddress
      name="reception_way"
      class="mb-4"
      @location-changed="emit('locationChanged')"
    />
      <InputTextarea
          name="comment"
          label="Комментарий к заказу"
          :rows="2"
      />

      <div class="mb-8 mt-2"> <HeadlessSwitchGroup> <InputSwitch name="leave_under_door"></InputSwitch> <HeadlessSwitchLabel class="ml-4">Оставить у двери</HeadlessSwitchLabel> </HeadlessSwitchGroup></div>


    <p class="mb-4">Когда доставить?</p>
    <OrderDialogSelectTime @date-changed="(d) => {emit('dateChanged', d)}" />
  </form>
</template>

<script setup lang="ts">

const emit = defineEmits(['locationChanged', 'dateChanged', 'leaveUnderDoorChanged'])
const { value } = useField<boolean>(() => "leave_under_door")
watch(value, (v) => {
    emit('leaveUnderDoorChanged', v)
}, { immediate: true })
</script>
